import React from "react";
import { Card, Button } from "@/components/ui";
import { Check, Crown } from "lucide-react";

export function PlanCard({ plan, trialDays, active, busy, onCheckout }) {
  const premium = plan.id === "premium";
  const paid = plan.amount_cents > 0;
  let cta;
  if (active) cta = <><Check className="w-4 h-4" /> Current plan</>;
  else if (paid) cta = `Start ${plan.name} trial`;
  else cta = "Choose Free forever";

  return (
    <Card data-testid={`plan-${plan.id}`} className={premium ? "border-brand ring-2 ring-brand/15" : ""}>
      <div className="flex items-center gap-2">
        {premium && <Crown className="w-5 h-5 text-mint-dark" />}
        <span className="font-display text-2xl text-ink">{plan.name}</span>
      </div>
      <div className="mt-1"><span className="font-display text-3xl text-brand-dark">${(plan.amount_cents / 100).toFixed(0)}</span><span className="text-subtle text-sm">/month</span></div>
      <p className="text-sm text-subtle mt-2">{plan.tagline}</p>
      {paid && <p className="text-xs text-subtle mt-1">{trialDays}-day free trial</p>}
      <Button
        data-testid={`subscribe-${plan.id}`}
        variant={premium ? "primary" : "secondary"}
        onClick={() => onCheckout(plan.id)}
        loading={busy}
        disabled={active}
        className="w-full mt-4">
        {cta}
      </Button>
    </Card>
  );
}
